var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiShieldCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6667 96.3334L34 73.6667L41.99 65.6767L56.6667 80.2967L94.01 42.9534L102 51.0001M68 5.66675L17 28.3334V62.3334C17 93.7834 38.76 123.193 68 130.333C97.24 123.193 119 93.7834 119 62.3334V28.3334L68 5.66675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiShieldCheck);
export default __webpack_public_path__ + "static/media/mdi_shield-check.bc9ecbd52a44ab9b0cfc3795dfda0347.svg";
export { ForwardRef as ReactComponent };